// extracted by mini-css-extract-plugin
export default {"navBlock":"Nav_navBlock__rBoEM","nav":"Nav_nav__dX7Zn"};